import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import DisplayContent from '../utils/DisplayContent';
import promotionConfig from '../promotion_config';
import ERROR_MESSAGES from '../contants/errorConstants';
import useLogger from '../hooks/useLogger';

const ErrorMessage = ({ errorMessage = 'ERROR_NOT_SET' }) => {
    const [fetchUrlTrigger, setFetchUrlTrigger] = useState(false);

    const errorMapping = {
        [ERROR_MESSAGES.NO_TICKET_DATA_PARAM]: 'RESCAN_NOW',
        [ERROR_MESSAGES.INVALID_TICKET_ENTER_RESPONSE]: 'RESCAN_NOW',
        [ERROR_MESSAGES.INVALID_TICKET_DATA]: 'RESCAN_NOW',
        [ERROR_MESSAGES.PLAY_PAGE_RELOADED]: 'RESCAN_NOW',

        [ERROR_MESSAGES.IGR_GAME_URL_NOT_RETURNED]: 'RESCAN_LATER',
        [ERROR_MESSAGES.IGR_NO_AUTH_TOKEN]: 'RESCAN_LATER',
        [ERROR_MESSAGES.IGR_AUTH_TOKEN_FAILURE]: 'RESCAN_LATER',
        [ERROR_MESSAGES.CMS_NO_SITE_ASSETS]: 'RESCAN_LATER',
        [ERROR_MESSAGES.CMS_NO_GAME_DATA]: 'RESCAN_LATER',
        [ERROR_MESSAGES.CMS_NO_ASSOCIATED_REVEAL_GAME]: 'RESCAN_LATER',
        [ERROR_MESSAGES.CMS_NO_REVEAL_GAME_DATA]: 'RESCAN_LATER',
        [ERROR_MESSAGES.CMS_NO_CREDENTIALS]: 'RESCAN_LATER',
        [ERROR_MESSAGES.INVALID_REVEAL_GAME_ID]: 'RESCAN_LATER',
    };

    const messageMapping = {
        RESCAN_NOW: 'Please rescan the QR code using a mobile device.',
        RESCAN_LATER: 'Please try rescanning the QR code later.',
    };

    const playerFacingMessage = errorMapping[errorMessage] ? messageMapping[errorMapping[errorMessage]] : messageMapping['RESCAN_LATER'];

    useLogger(fetchUrlTrigger ? errorMessage : null);

    useEffect(() => {
        setFetchUrlTrigger(true);
    }, [errorMessage]);

    return (
        <div className={`error-message ${errorMessage}`}>
            <Helmet>
                <title>Error - Scratch Connect</title>
            </Helmet>
            <div className='error-content'>
                <DisplayContent note='Warning logo image' isVisible={promotionConfig?.assets?.circleExclamation?.ref}>
                    <div id='error-content-exclamation' className='error-content-exclamation'>
                        <img src={promotionConfig?.assets?.circleExclamation?.ref} alt={promotionConfig?.assets?.circleExclamation?.alt} />
                    </div>
                </DisplayContent>
                <p>{playerFacingMessage}</p>
            </div>
        </div>
    );
};

export default ErrorMessage;
